/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from '../utils/async_utils';
import { FETCH_SEASONS } from '../constants/actions';
import { getSeasons } from '../api/index';

export const fetchSeasons = makeAsyncAction(
    FETCH_SEASONS,
    (id: string, year: string) => () => getSeasons(id, year),
    'Seasons'
);
